import './Stamp.css'

// Rotating rubber stamp shown over the hero.
export default function Stamp() {
    return (
        <div className='stamp' aria-hidden='true'>
            <svg viewBox='0 0 200 200' width='100%' height='100%'>
                <defs>
                    <path id='stamp-circle' d='M100,100 m-72,0 a72,72 0 1,1 144,0 a72,72 0 1,1 -144,0'/>
                </defs>
                <circle cx='100' cy='100' r='96' fill='none' stroke='#a8452a' strokeWidth='3'/>
                <circle cx='100' cy='100' r='52' fill='none' stroke='#a8452a' strokeWidth='1.5' strokeDasharray='4 4'/>
                <text className='stamp-ring'>
                    <textPath href='#stamp-circle' textLength='448' lengthAdjust='spacingAndGlyphs'>
                        AVAILABLE FOR FREELANCE · OPEN TO TEAMS ·
                    </textPath>
                </text>
                <text className='stamp-initials' x='100' y='112' textAnchor='middle'>VL</text>
            </svg>
        </div>
    )
}
